import PropTypes from 'prop-types'

/* types */
import { locationShape } from '../../../types/locationShape'
import { commentsShape } from '../../../types/commentsShape'
import { avatarShape } from '../../../types/avatarShape'
import { ratingShape } from '../../../types/ratingShape'


export const propTypesStructure = {
  avatar: PropTypes.shape(avatarShape),
  description: PropTypes.string,
  id: PropTypes.number,
  location: PropTypes.shape(locationShape),
  name: PropTypes.string,
  user_id: PropTypes.number,
}

export const propTypes = {
  comments: PropTypes.arrayOf(PropTypes.shape(commentsShape)),
  days_for_request: PropTypes.number.isRequired,
  discounts: PropTypes.arrayOf(PropTypes.shape({
    daysPeriod: PropTypes.string,
    priceAdult: PropTypes.number,
    priceChild: PropTypes.number,
  })),
  duration: PropTypes.number.isRequired,
  end_date: PropTypes.string.isRequired,
  exception_dates: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.string,
  })).isRequired,
  fullPackages: PropTypes.arrayOf(PropTypes.shape({
    age: PropTypes.string,
    days: PropTypes.number,
    price: PropTypes.number,
  })).isRequired,
  host: PropTypes.shape(propTypesStructure).isRequired,
  location: PropTypes.shape(locationShape).isRequired,
  location_about: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  package: PropTypes.object,
  package_photos: PropTypes.array,
  package_video_url: PropTypes.string,
  photos: PropTypes.array,
  rating: PropTypes.shape(ratingShape),
  rules: PropTypes.string,
  slug: PropTypes.string.isRequired,
  start_date: PropTypes.string.isRequired,
  subtheme: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  summary: PropTypes.string,
  theme: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  updated_at: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
  })),
  video_url: PropTypes.string,
  volunteer_task: PropTypes.string,
  volunteers: PropTypes.PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number,
  ]),
  id: PropTypes.number.isRequired,
}

export const propsDefault = {
  comments: [],
  discounts: [],
  location_about: '',
  name: '',
  options: [],
  package: '',
  package_video_url: '',
  package_photos: [],
  photos: [],
  rating: {},
  rules: '',
  summary: '',
  updated_at: [],
  video_url: '',
  volunteer_task: '',
  volunteers: [],
}
